import React, { useMemo } from 'react'
import { InboxType } from '../../../../server/models/Inbox'
import { useSourcesCountQuery } from '../../../requests/sources'
import { useInboxMembersCountQuery } from '../../../requests/inboxMembers'
import './styles.css'

type Props = {
  inbox: InboxType
  onClick: (inbox: InboxType) => void
  selected: boolean
}

export const OneInboxToJoin: React.FC<Props> = ({
  inbox,
  onClick,
  selected
}) => {
  const sevenDaysAgo = useMemo(() => {
    const now = new Date()
    return new Date(now.setDate(now.getDate() - 7))
  }, [])

  const {
    isLoading: isLoadingSources,
    data: sourcesCount = 0
  } = useSourcesCountQuery(inbox._id, { startDate: sevenDaysAgo, ignore: false })

  const {
    data: memberCount = 0,
    isLoading: isLoadingMembers
  } = useInboxMembersCountQuery(inbox._id)

  const handleClick = () => {
    onClick(inbox)
  }

  const className = useMemo(() => {
    const classes = ['join-inbox']

    if (selected) {
      classes.push('selected')
    }

    return classes.join(' ')
  }, [selected])

  const memberCountText = useMemo(() => {
    if (isLoadingMembers) {
      return 'counting members...'
    }

    if (memberCount === 1) {
      return '1 member'
    }

    return `${memberCount} members`
  }, [isLoadingMembers, memberCount])

  if (isLoadingSources || sourcesCount === 0) {
    return null
  }

  return (
    <button className={className} onClick={handleClick} type="button">
      <h3>{inbox.name}</h3>
      <div className="stats">
        <span>{sourcesCount} new source{ sourcesCount === 1 ? '' : 's' } a week</span>
        <span>•</span>
        <span>{memberCountText}</span>
      </div>
    </button>
  )
}

